import React from 'react';
import {
    Card,
    Layout,
    Page,
    Stack,
    Button
} from '@shopify/polaris';
import { Helmet } from 'react-helmet';
import OperationPreviewComponent from '../components/OperationPreviewComponent';


class TagWorkflowPreviewComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    render() {

        const hasTagActions = this.props.preview.resourcePreviews.length > 0;
        const submitAction = { content: "Execute Operation", onAction: this.onSubmitOperation };
        const saveAction = { content: "Save Operation", onAction: this.onSaveOperation };

        let primaryAction = submitAction;

        if (!hasTagActions) {
            primaryAction = saveAction;
        }

        var actions = <Stack distribution="trailing">
            <Stack.Item>
                <Button onClick={this.onEditOperation}>Back</Button>
            </Stack.Item>
            <Stack.Item>
                <Button onClick={this.onSaveOperation}>Save Operation</Button>
            </Stack.Item>
            <Stack.Item>
                <Button primary onClick={this.onSubmitOperation}>Save and Execute Operation</Button>
            </Stack.Item>
        </Stack>;

        if (!hasTagActions) {
            actions = <Stack distribution="trailing">
                <Stack.Item>
                    <Button onClick={this.onEditOperation}>Back</Button>
                </Stack.Item>
                <Stack.Item>
                    <Button primary onClick={this.onSaveOperation}>Save Operation</Button>
                </Stack.Item>
            </Stack>;
        }

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Create Tag Operation</title>
                </Helmet>
                <Page
                    title={this.props.title}
                    primaryAction={primaryAction}>
                    <Layout>
                        <Layout.Section>
                            <Card
                                title="PREVIEW TAG OPERATION">
                                <Card.Section>
                                    <OperationPreviewComponent preview={this.props.preview} />
                                </Card.Section>
                                <Card.Section>
                                    {actions}
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div>
        );
    }

    onSubmitOperation = () => {
        this.props.onSubmit({
            actions: this.props.operation.actions,
            productFilters: this.props.operation.productFilters,
            productFiltersLogicalOperator: this.props.operation.productFiltersLogicalOperator,
            description: this.props.operation.description
        });
    }

    onSaveOperation = () => {
        this.props.onCreate({
            actions: this.props.operation.actions,
            productFilters: this.props.operation.productFilters,
            productFiltersLogicalOperator: this.props.operation.productFiltersLogicalOperator,
            description: this.props.operation.description
        });
    }

    onEditOperation = async () => {
        this.props.onEdit();
    }

    componentDidMount() {
    }
}

TagWorkflowPreviewComponent.defaultProps = {
    actionButtonText: "Save Operations",
    title: "Create Bulk Tag Operation"
}

export default TagWorkflowPreviewComponent;

